
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import QRCode from "qrcodejs2"; //
import { Qr } from "@/lib/model/common";

@Component({})
export default class MessageDialog extends Vue {
  @Prop({}) CodeText!: any;
  @Prop({ default: false }) notUseQrjs!: boolean; //二维码从后端拉取
  show = false;

  // @Watch("CodeText.coderImgUrl", { deep: true })
  // changeQr(n: any, o: any) {
  //   debugger;
  //   if (n) {
  //     const a = this.CodeText.coderImgUrl;
  //     this.$nextTick(() => {
  //       this.getQR();
  //     });
  //   }
  // }

  created() {
    //
  }
  mounted() {
    //
    if (this.notUseQrjs) return;
    setTimeout(() => {
      this.getQR();
    }, 100);
  }
  qrImg = "";
  ok() {
    // this.$emit("ok", this.exam.templateName);
    //
  }
  //父组件是pop时使用
  async getQrServe() {
    this.show = false;
    setTimeout(async () => {
      const t = await Qr.getQrImage(this.CodeText.coderImgUrl);
      this.qrImg = t.linkImage;
      this.$nextTick(() => {
        this.show = true;
      });
    }, 1000);
  }
  getQR() {
    if (!this.CodeText.coderImgUrl) return;
    const key = "qrcode" + this.CodeText.coderImgUrl;
    if (!document.getElementById(key)) return;
    (document.getElementById(key) as any).innerHTML = "";
    // if (document.getElementById(key)) {
    //   (document.getElementById(key) as any).innerHTML = "";
    // }
    // if (
    //   document.getElementById(key) &&
    //   !(document.getElementById(key) as any).innerHTML
    // ) {
    this.$nextTick(() => {
      new QRCode(document.getElementById(key), {
        width: 120,
        height: 120,
        text: this.CodeText.coderImgUrl, // 二维码地址
        colorDark: "black",
        colorLight: "white"
      });
    });
    setTimeout(() => {
      this.show = true;
    }, 500);
  }

  //关闭
  close() {
    this.$emit("cancelMessage", false);
  }
}
